import React from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";

const Footer = props => {
  const { theme } = props;
  const buildTime = useStaticQuery(query).site.buildTime

  return (
    <React.Fragment>
      <footer className="footer">
        <p>cities-skylines.info <a href="https://twitter.com/fuchika_jp/">(@fuchika_jp)</a> All rights reserved.
          最後の更新日時は、グリニッジ標準時で{buildTime}です。
        </p> 
      </footer> 

      {/* --- STYLES --- */}
      <style jsx>{`
        .footer {
          background: ${theme.color.neutral.white};
          padding: ${theme.space.inset.default};
          text-align: center;
          color: ${theme.color.neutral.gray.g};
          font-size: ${theme.font.size.xxs};
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 60px;
        }
      `}</style>
    </React.Fragment>
  );
};

Footer.propTypes = {
  theme: PropTypes.object.isRequired
};

export default Footer;

const query = graphql`
  query Info {
    site {
      buildTime(formatString: "YYYY.MM.DD HH:mm")
    }
  }
`

//20210131 著作権者に@fuchika_netを加え、リンクにhttps://twitter.com/fuchike_net/を設定した。